module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-public-notice",
    attrs: {
      "id": "correctNotice"
    }
  }, [_c('search-panel', {
    attrs: {
      "searchdata": _vm.searchdata,
      "showBtn": _vm.showBtn,
      "tableCode": _vm.table_init.table_code,
      "dirs": _vm.dirs
    },
    on: {
      "passLimit": _vm.getLimit
    }
  }), _vm._v(" "), _c('base-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中，请稍候",
      "dirs": _vm.dirs,
      "tableInit": _vm.table_init
    },
    on: {
      "passcurrentRow": function (val) {
        _vm.currentRow = val[0].currentRow
      },
      "sortChange": _vm.sortChange,
      "queryItem": _vm.queryItem
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "total": _vm.totalPage
    },
    on: {
      "paginationChange": _vm.paginationChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d42c97d6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/homepage/correctNotice.vue
// module id = 605
// module chunks = 143